import { app } from '../../../../app';
import { groupTypeLabel } from '../../../../components/sp-group-type/sp-group-type.exports';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group', {
        url: '/manage-group/:groupId',
        redirectTo: 'company.user-directories.manage-group.settings',
        component: 'companyUserDirectoriesManageGroup',
        resolve: {
            $breadcrumbs,
            group,
            groupId,
        },
    });
}

/** @ngInject */
function $breadcrumbs($q, $translate, group) {
    return (() => {
        if (group.groupName === group.type) {
            return $translate(groupTypeLabel(group.type));
        } else {
            return $q.resolve(group.groupName);
        }
    })().then((title) => [
        {
            stateName: 'company.user-directories.directory-groups',
        },
        {
            stateName: 'company.user-directories.directory-groups.directory',
            stateParams: {directoryId: (group.directory || {}).id},
            title: (group.directory || {}).name || 'SAASPASS Directory & Groups',
        },
        {
            title,
        },
    ])
}

/** @ngInject */
function groupId($stateParams) {
    return $stateParams.groupId;
}

/** @ngInject */
function group(companyId, groupId, GroupsResource) {
    return GroupsResource.getGroupById(companyId, groupId)
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/manage-group.state.js